<template>
  <div class="modal modal-system-user">
    <div class="modal-system-user-wrapper">
      <i class="icon-close" @click="$emit('closeModal')"></i>
      <div class="modal-system-user__content">
        <md-field>
          <label for="name-system-user">Nombre</label>
          <md-input
            name="name-system-user"
            id="name-system-user"
            v-model="firstName"
            aria-placeholder="Nombre de Usuario de sistema"
          ></md-input>
        </md-field>
        <md-field>
          <label for="lastname-system-user">Apellidos</label>
          <md-input
            name="lastname-system-user"
            id="lastname-system-user"
            v-model="lastName"
            aria-placeholder="Apellidos de Usuario de sistema"
          ></md-input>
        </md-field>
        <md-field>
          <label for="email-system-user">Correo Electrónico</label>
          <md-input
            name="email-system-user"
            id="email-system-user"
            v-model="email"
            aria-placeholder="Correo electrónico"
            type="email"
          ></md-input>
        </md-field>
        <md-field>
          <label for="password-system-user">Contraseña</label>
          <md-input
            name="password-system-user"
            id="password-system-user"
            v-model="password"
            aria-placeholder="Contraseña"
            type="password"
          ></md-input>
        </md-field>
        <md-field v-if="user">
          <label for="role-system-user">Rol</label>
          <md-select v-model="role" name="role-system-user" role="role-system-user">
            <md-option v-for="rol in roles" :value="rol.value" :key="`rol-${rol.value}`">{{rol.label}}</md-option>
          </md-select>
        </md-field>
        <md-field v-if="user">
          <label for="business-system-user">Empresa</label>
          <md-select
            v-model="businesses"
            aria-placeholder="Seleccione la empresa"
            name="business-system-user"
            id="business-system-user"
            multiple
          >
            <md-option
              :value="item.id"
              v-for="(item, $index) of businessList"
              :key="`select-system-business-${$index}`"
            >{{item.name}}</md-option>
          </md-select>
        </md-field>
        <md-button
          class="md-raised md-accent"
          @click="createUser"
        >{{!!this.user? "Actualizar Usuario":"Crear Usuario"}}</md-button>
      </div>
    </div>
  </div>
</template>

<script>
import {service} from "../../api/api"
export default {
  name: "ModalSystemUser",
  props: ["user"],
  data() {
    return {
      firstName: null,
      lastName: null,
      email: null,
      password: undefined,
      role: undefined,
      businesses: [],
      localBusiness: [],
      businessListAux: [],
      roles: [
        {
          value: 'owner',
          label: 'Dueño'
        },
        // {
        //   value: 'master',
        //   label: 'Maestro'
        // },
        // {
        //   value: 'manager',
        //   label: 'Administrador'
        // },
        {
          value: 'normal',
          label: 'Empleado'
        },
        {
          value: 'guest',
          label: 'Invitado'
        }
      ]
    };
  },
  beforeCreate() {
    this.$store.dispatch("getBusiness");
    
  },
  async created() {
    // console.log(service);
    
    this.businessListAux = await service.getBusinessAux({page: 1, limit:100})
    console.log(this.businessListAux.data.results);
    
    if (this.user) {
      console.log(this.user);

      this.firstName = this.user.firstName;
      this.lastName = this.user.lastName;
      this.email = this.user.email;
      this.role = this.user.roleIn;
      this.businesses = this.user.business ? this.user.business.map(b => b.id) : [];
      this.localBusiness = this.user.business.map(b => b.id);
    }
  },
  computed: {
    businessList() {
      
      if(!this.businessListAux.data) return []

      return this.businessListAux.data.results;
    }
  },
  methods: {
    createUser() {
      if (!this.user) {
        this.$store
          .dispatch("setSystemUsers", {
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            password: this.password,
            roleIn: this.role
          })
          .then(res => {
            if (res.status == 200) {
              this.$toasted.success(`Usuario creado`, {
                theme: "bubble",
                position: "top-right",
                duration: 5000,
                className: "short-message"
              });
              this.$store.dispatch("getSystemUsers");
              this.$emit("closeModal");
            }
          });
      } else {
        if(this.firstName === this.user.firstName && this.lastName === this.user.lastName && this.email === this.user.email && !this.password && this.role === this.user.roleIn){
          this.$emit("closeModal");
          return
        }
        this.$store
          .dispatch("updateSystemUserInfo", {
            id: this.user.id,
            body: {
              firstName: this.firstName,
              lastName: this.lastName,
              email: this.email,
              password: this.password,
              roleIn: this.role
            }
          })
          .then(res => {
            if (res.status == 200) {
              this.$toasted.success(`Usuario actualizado`, {
                theme: "bubble",
                position: "top-right",
                duration: 5000,
                className: "short-message"
              });
              this.$store.dispatch("getSystemUsers");
              this.$emit("closeModal");
            }else {
              this.$toasted.show(`Error en consulta`, {
                theme: "bubble",
                position: "top-right",
                duration: 5000,
                className: "short-message"
              });
            }
          });
      }
    },
    linkBusiness(businessId) {
      this.$store
        .dispatch("linkSystemUsersBusiness", {
          id: this.user.id,
          fk: businessId,
          body: {
            role: this.role || "normal"
          }
        })
        .then(res => {
          if (res.status == 200) {
            this.$toasted.success(`Empresa agregado a Usuario de sistema`, {
              theme: "bubble",
              position: "top-right",
              duration: 5000,
              className: "short-message"
            });
            this.$store.dispatch("getSystemUsers");
            // this.$emit("closeModal");
          }
        });
    },
    unlinkBusiness(businessId) {
      this.$store
        .dispatch("unlinkSystemUsersBusiness", {
          id: this.user.id,
          fk: businessId
        })
        .then(res => {
          if (res.status == 200) {
            this.$toasted.success(`Empresa quitada a Usuario de sistema`, {
              theme: "bubble",
              position: "top-right",
              duration: 5000,
              className: "short-message"
            });
            this.$store.dispatch("getSystemUsers");
            // this.$emit("closeModal");
          }
        });
    }
  },
  watch: {
    businesses: function(n,o){
      console.log("in watch");
      if(n.length > o.length){
        const id = n.find(id => !o.includes(id));
        this.linkBusiness(id);
      }
      if(n.length < o.length){
        const id = o.find(id => !n.includes(id));
        this.unlinkBusiness(id)
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;

.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 120;
}
.modal-system-user {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  // width: 60%;
}
.modal-system-user-wrapper {
  position: relative;
  width: 50%;
  min-width: 320px;
}
.icon-close {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #ffffff;
  text-align: center;
  // border: thin solid #cdcdcd;
  box-shadow: 0px 0.5px 2px 1px rgba(0, 0, 0, 0.5);
  padding: 0.3rem 0.5rem;
  cursor: pointer;
  border-radius: 50%;
}
.modal-system-user__content {
  background-color: #ffffff;
  padding: 2rem;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;
  // width: 100%;
}
</style>